// extracted by mini-css-extract-plugin
export default {"card":"FloatCard_card__Swq-6","row":"FloatCard_row__e1IKC"};